import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'prop-types';
import * as React from 'react';
import { Svg } from '../Icon/Base.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["color"];
var IconGoogleDrive = /*#__PURE__*/React.memo(function (_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(Svg, _objectSpread(_objectSpread({
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: [/*#__PURE__*/jsx("path", {
      d: "M17.42 10.14L14.015 4h-4.6l-6.1 11 2.1 4h8.103a6.03 6.03 0 001.88 2H5.414c-.7 0-1.4-.4-1.8-1.1l-2.1-4c-.3-.6-.3-1.3 0-1.9l6.2-11c.3-.6 1-1 1.7-1h4.6c.7 0 1.4.4 1.8 1l3.93 7.088a6.035 6.035 0 00-2.325.052z",
      fill: color
    }), /*#__PURE__*/jsx("path", {
      d: "M14.938 11.338L12.614 7.4h-1.8l-4.5 7.8.7 1.3h5.72a6.081 6.081 0 01.169-2H9.015l2.7-4.8 1.83 3.253a6.027 6.027 0 011.393-1.615zM17.715 16.73l-1.833-1.784-1.167 1.135 3 2.919 5-4.865L21.548 13l-3.833 3.73z",
      fill: color
    })]
  }));
});
IconGoogleDrive.displayName = "IconGoogleDrive";

export { IconGoogleDrive };
